import { createSlice, createAsyncThunk, isAnyOf } from '@reduxjs/toolkit';
import { showToast } from 'Core/redux/toast/slice';
import { closeModal, showModal } from 'Core/redux/main/slice';
import { redux } from 'Core/redux';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { WorkTicketService } from '../../../service/api/work-ticket';

const { WORKTICKET_ADD_EDIT } = MODAL_TYPES;

export const STORE_KEY = 'workTicket';
export const INITIAL_STATE = {
  data: [],
  loading: false,
  error: null,
  filters: {
    searchText: '',
    fromDate: null,
    toDate: null,
  },
  workTicketLoading : false,
  filterVisible: false,
  tileView: false,
  selectedWorkTicket: null,
  editModalVisible: false,
};

export const fetchWorkTickets = createAsyncThunk(
  'workticket/fetchWorkTickets',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await WorkTicketService.getAllWorkTicket(filters);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to load Work Ticket');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load  WorkTicket');
    }
  },
);

export const addWorkTicket = createAsyncThunk(
  'workticket/addWorkTicket',
  async (workTicketPayload, { rejectWithValue }) => {
    try {
      const response = await WorkTicketService.createWorkTicket(workTicketPayload);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to add Work Ticket');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to add Work Ticket');
    }
  },
);


 export const editWorkTicket = createAsyncThunk(
  'workTicket/editWorkTicket',
  async (workTicketPayload, { rejectWithValue }) => {
    try {
      const response = await WorkTicketService.createWorkTicket(workTicketPayload);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to update Work Ticket');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to update Work Ticket');
    }
  },
);

export const editWorkTicketData = createAsyncThunk(
  'workTicket/editWorkTicketData',
  async (WORKORDERID, { rejectWithValue }) => {
    try {
      const response = await WorkTicketService.getWorkTicketByWorkOrderId(WORKORDERID);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to load WorkTicket data');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load WorkTicket data');
    }
  },
);



export const fetchWorkTicketWithFilters = () => (dispatch, getState) => {
  const filters = getState().workTicket.filters;
  dispatch(
    fetchWorkTickets({
      searchText: filters.searchText,
      fromDate: filters?.fromDate,
      toDate: filters?.toDate,
    }),
  );
};



export const { reducer, actions } = createSlice({
  name: 'workTicket',
  initialState: INITIAL_STATE,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    resetFilters: state => {
      state.filters = INITIAL_STATE.filters;
    },
    setFilterVisible: (state, action) => {
      state.filterVisible = action.payload;
    },
    setSearchText: (state, action) => {
      state.filters.searchText = action.payload;
    },
    setFromDate: (state, action) => {
      state.filters.fromDate = action.payload;
    },
    setToDate: (state, action) => {
      state.filters.toDate = action.payload;
    },
    setTileView: (state, action) => {
      state.tileView = action.payload; // Add reducer to update tileView
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchWorkTickets.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorkTickets.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchWorkTickets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addWorkTicket.fulfilled, (state, action) => {
        const newWorkTicket = {
          ...action.payload,
          isNewlyCreated: true,
        };
        state.data = [newWorkTicket, ...state.data];
      })
      .addCase(addWorkTicket.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(editWorkTicket.fulfilled, (state, action) => {
        const index = state.data.findIndex(s => s.id === action.payload.id);
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(editWorkTicket.rejected, (state, action) => {
        state.error = action.payload;
      })
      // .addCase(deleteWorkTicket.fulfilled, (state, action) => {
      //   const newData = state.data.filter(s => s.id !== action.payload);
      //   state.data = newData;
      // })
      .addCase(editWorkTicketData.pending, state => {
        state.workTicketLoading = true;
      })
      .addCase(editWorkTicketData.fulfilled, state => {
        state.workTicketLoading = false;
      })
      .addCase(editWorkTicketData.rejected, state => {
        state.workTicketLoading  = false;
      });
  },
});

redux.listener.startListening({
  matcher: isAnyOf(addWorkTicket.rejected, editWorkTicket.rejected, editWorkTicketData.rejected),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(
      showToast({
        message: action.payload,
        type: 'danger',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(addWorkTicket.fulfilled, editWorkTicket.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(closeModal(WORKTICKET_ADD_EDIT)); 
    listenerApi.dispatch(fetchWorkTicketWithFilters());
    listenerApi.dispatch(
      showToast({
        message: 'Work Ticket success',
        type: 'success',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(editWorkTicketData.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(showModal(WORKTICKET_ADD_EDIT, action.payload));
  },
});

// redux.listener.startListening({
//   matcher: isAnyOf(deleteWorkTicket.fulfilled),
//   effect: (action, listenerApi) => {
//     listenerApi.dispatch(
//       showToast({
//         message: 'Work Ticket deleted successfully',
//         type: 'success',
//       }),
//     );
//   },
// });

redux.injectReducer(STORE_KEY, reducer);
